// Documentação e Treinamento: ranking de motivos dos cards (com manuais ligados), produção e utilidade dos manuais,
// demandas editoriais, treinamentos e relatório do período. Permissões documentacao.* e treinamentos.gerenciar.
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Paper, Tab, Table, TableBody, TableCell,
  TableHead, TableRow, Tabs, TextField, Typography,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import suporteApi, { mensagemErro } from "../api";
import { dataBR } from "../comum";
import { usePermissao } from "../permissoes";

const SIT = { SOLICITADO: "Solicitado", EM_PRODUCAO: "Em produção", EM_REVISAO: "Em revisão", AJUSTES: "Ajustes necessários",
  APROVADO: "Aprovado", PUBLICADO: "Publicado", ARQUIVADO: "Arquivado" };
// próximos passos do fluxo editorial (o servidor confere)
const PROXIMOS = { SOLICITADO: ["EM_PRODUCAO", "ARQUIVADO"], EM_PRODUCAO: ["EM_REVISAO", "ARQUIVADO"], EM_REVISAO: ["AJUSTES", "APROVADO"],
  AJUSTES: ["EM_PRODUCAO"], APROVADO: ["PUBLICADO"] };
const PART = { NAO_INICIOU: "Não iniciou", EM_ANDAMENTO: "Em andamento", CONCLUIU: "Concluiu", PRECISA_REFORCO: "Precisa de reforço" };
const hojeIso = () => new Date().toISOString().slice(0, 10);
const somaDias = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
const abrirHtml = async (url, params) => {
  try {
    const { data } = await suporteApi.get(url, { params, responseType: "text" });
    const j = window.open("", "_blank");
    if (j) { j.document.write(data); j.document.close(); }
  } catch (e) { toast.error(mensagemErro(e)); }
};

const Numero = ({ rotulo, valor }) => (
  <Paper variant="outlined" style={{ padding: "8px 14px", minWidth: 130 }}>
    <Typography variant="h6">{valor ?? "—"}</Typography><Typography variant="caption">{rotulo}</Typography>
  </Paper>
);

const LigarManual = ({ motivo, manuais, onClose, onSalvo }) => {
  const [id, setId] = useState("");
  if (!motivo) return null;
  const salvar = async () => {
    try {
      await suporteApi.post("/api/documentacao/motivos-manuais", { causa: motivo, manual_id: Number(id) });
      onSalvo();
      onClose();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Manual para “{motivo}”</DialogTitle>
      <DialogContent>
        <TextField select fullWidth size="small" label="Manual" value={id} onChange={(e) => setId(e.target.value)}>
          {manuais.map((m) => <MenuItem key={m.id} value={m.id}>{m.titulo}</MenuItem>)}
        </TextField>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Cancelar</Button><Button color="primary" disabled={!id} onClick={salvar}>Ligar</Button></DialogActions>
    </Dialog>
  );
};

const NovaDemanda = ({ open, inicial, onClose, onSalvo }) => {
  const [f, setF] = useState({});
  useEffect(() => { if (open) setF({ tema: "", acao: "CRIAR", prioridade: "MEDIA", responsavel: "", prazo: "", ...inicial }); }, [open, inicial]);
  const salvar = async () => {
    try {
      await suporteApi.post("/api/documentacao/demandas", { ...f, prazo: f.prazo || null, responsavel: f.responsavel || null });
      toast.success("Demanda registrada");
      onSalvo();
      onClose();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const c = (k, rotulo, extra = {}) => <TextField size="small" margin="dense" fullWidth label={rotulo} value={f[k] ?? ""}
    onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} />;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Nova demanda de documentação</DialogTitle>
      <DialogContent>
        {c("tema", "Tema")}
        <div style={{ display: "flex", gap: 8 }}>
          {c("acao", "Ação", { select: true, children: ["CRIAR", "ATUALIZAR", "ORIENTAR", "TREINAR"].map((a) => <MenuItem key={a} value={a}>{a}</MenuItem>) })}
          {c("prioridade", "Prioridade", { select: true, children: ["BAIXA", "MEDIA", "ALTA"].map((a) => <MenuItem key={a} value={a}>{a}</MenuItem>) })}
        </div>
        <div style={{ display: "flex", gap: 8 }}>{c("responsavel", "Responsável")}{c("prazo", "Prazo", { type: "date", InputLabelProps: { shrink: true } })}</div>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Cancelar</Button><Button color="primary" variant="contained" disabled={(f.tema || "").length < 3} onClick={salvar}>Registrar</Button></DialogActions>
    </Dialog>
  );
};

const NovoTreinamento = ({ open, manuais, onClose, onSalvo }) => {
  const [f, setF] = useState({});
  useEffect(() => { if (open) setF({ titulo: "", objetivo: "", publico: "", instrutor: "", modalidade: "Presencial", data: `${somaDias(hojeIso(), 7)}T14:00`, manuais: [] }); }, [open]);
  const salvar = async () => {
    try {
      await suporteApi.post("/api/documentacao/treinamentos", f);
      onSalvo();
      onClose();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const c = (k, rotulo, extra = {}) => <TextField size="small" margin="dense" fullWidth label={rotulo} value={f[k] ?? ""}
    onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} />;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Novo treinamento</DialogTitle>
      <DialogContent>
        {c("titulo", "Título")}
        {c("objetivo", "Objetivo (o que o técnico deve saber fazer)", { multiline: true, minRows: 2 })}
        <div style={{ display: "flex", gap: 8 }}>{c("publico", "Público")}{c("instrutor", "Instrutor")}</div>
        <div style={{ display: "flex", gap: 8 }}>
          {c("modalidade", "Modalidade", { select: true, children: ["Presencial", "Online", "Em campo"].map((a) => <MenuItem key={a} value={a}>{a}</MenuItem>) })}
          {c("data", "Data", { type: "datetime-local", InputLabelProps: { shrink: true } })}
        </div>
        <TextField select size="small" margin="dense" fullWidth label="Materiais (manuais)" SelectProps={{ multiple: true }}
          value={f.manuais || []} onChange={(e) => setF({ ...f, manuais: e.target.value })}>
          {manuais.map((m) => <MenuItem key={m.id} value={m.id}>{m.titulo}</MenuItem>)}
        </TextField>
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Cancelar</Button>
        <Button color="primary" variant="contained" disabled={(f.titulo || "").length < 3 || (f.objetivo || "").length < 5} onClick={salvar}>Criar</Button></DialogActions>
    </Dialog>
  );
};

const DetalheTreinamento = ({ id, onClose, onMudou }) => {
  const [t, setT] = useState(null);
  const [p, setP] = useState({ nome: "", presente: true, situacao: "CONCLUIU" });
  const [resultado, setResultado] = useState("");
  const pode = usePermissao("treinamentos.gerenciar");
  const carregar = useCallback(() => {
    if (id) suporteApi.get(`/api/documentacao/treinamentos/${id}`).then((r) => setT(r.data)).catch((e) => toast.error(mensagemErro(e)));
  }, [id]);
  useEffect(() => { setT(null); carregar(); }, [carregar]);
  if (!id) return null;
  const incluir = async () => {
    try {
      await suporteApi.post(`/api/documentacao/treinamentos/${id}/participantes`, p);
      setP({ ...p, nome: "" });
      carregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const concluir = async (status) => {
    try {
      setT((await suporteApi.put(`/api/documentacao/treinamentos/${id}`, { status, resultado: resultado || null })).data);
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t ? t.titulo : "Treinamento"}</DialogTitle>
      <DialogContent>
        {t && (
          <>
            <Typography variant="body2">{t.objetivo}</Typography>
            <Typography variant="caption" component="div">{t.modalidade || ""} · {t.data ? dataBR(t.data) : "sem data"} · {t.instrutor || "—"} · <b>{t.status}</b></Typography>
            <Typography variant="subtitle2" style={{ marginTop: 8 }}>Materiais</Typography>
            {(t.materiais || []).map((m) => <Typography key={m.manual_id} variant="body2">• {m.titulo} (versão {m.versao})</Typography>)}
            <Typography variant="subtitle2" style={{ marginTop: 8 }}>Participantes ({(t.participantes || []).length})</Typography>
            {(t.participantes || []).map((x) => (
              <Typography key={x.id} variant="body2">• {x.nome} — {x.presente ? "presente" : x.presente === false ? "faltou" : "?"} · {PART[x.situacao]}</Typography>
            ))}
            {pode && t.status !== "REALIZADO" && (
              <>
                <div style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 6 }}>
                  <TextField size="small" label="Nome" value={p.nome} onChange={(e) => setP({ ...p, nome: e.target.value })} />
                  <TextField select size="small" label="Presença" value={p.presente ? "s" : "n"} onChange={(e) => setP({ ...p, presente: e.target.value === "s" })}>
                    <MenuItem value="s">Presente</MenuItem><MenuItem value="n">Faltou</MenuItem>
                  </TextField>
                  <TextField select size="small" label="Situação" value={p.situacao} onChange={(e) => setP({ ...p, situacao: e.target.value })} style={{ minWidth: 150 }}>
                    {Object.entries(PART).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
                  </TextField>
                  <Button size="small" disabled={p.nome.length < 2} onClick={incluir}>Incluir</Button>
                </div>
                <Typography variant="caption">Presença não é competência: “Concluiu” só para quem demonstrou na prática.</Typography>
                <TextField size="small" margin="dense" fullWidth label="Resultado (como foi avaliado)" value={resultado} onChange={(e) => setResultado(e.target.value)} />
                <Button size="small" color="primary" variant="outlined" onClick={() => concluir("REALIZADO")}>Marcar como realizado</Button>
                <Button size="small" onClick={() => concluir("CANCELADO")}>Cancelar treinamento</Button>
              </>
            )}
            {t.resultado && <Typography variant="body2" style={{ marginTop: 8 }}><b>Resultado:</b> {t.resultado}</Typography>}
          </>
        )}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
    </Dialog>
  );
};

const Documentacao = () => {
  const [aba, setAba] = useState("ranking");
  const [per, setPer] = useState({ de: somaDias(hojeIso(), -30), ate: hojeIso() });
  const [ranking, setRanking] = useState(null);
  const [prod, setProd] = useState(null);
  const [demandas, setDemandas] = useState([]);
  const [treinos, setTreinos] = useState([]);
  const [manuais, setManuais] = useState([]);
  const [ligar, setLigar] = useState(null);
  const [nova, setNova] = useState(null);
  const [novoT, setNovoT] = useState(false);
  const [treino, setTreino] = useState(null);
  const gerencia = usePermissao("documentacao.gerenciar");
  const treina = usePermissao("treinamentos.gerenciar");

  const carregar = useCallback(() => {
    suporteApi.get("/api/documentacao/ranking", { params: per }).then((r) => setRanking(r.data)).catch((e) => toast.error(mensagemErro(e)));
    suporteApi.get("/api/documentacao/producao", { params: per }).then((r) => setProd(r.data)).catch(() => {});
    suporteApi.get("/api/documentacao/demandas").then((r) => setDemandas(r.data.itens)).catch(() => {});
    suporteApi.get("/api/documentacao/treinamentos").then((r) => setTreinos(r.data)).catch(() => {});
  }, [per]);
  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => { suporteApi.get("/api/manuais").then((r) => setManuais(r.data.itens || r.data)).catch(() => {}); }, []);
  const fecharTreino = useCallback(() => setTreino(null), []);

  const andar = async (d, status) => {
    const corpo = { status };
    if (status === "PUBLICADO") {
      const id = window.prompt("ID do manual publicado:", d.manual_id || "");
      if (!id) return;
      corpo.manual_id = Number(id);
    }
    try { await suporteApi.put(`/api/documentacao/demandas/${d.id}`, corpo); carregar(); } catch (e) { toast.error(mensagemErro(e)); }
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>Documentação e Treinamento</Title>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <TextField size="small" type="date" label="De" InputLabelProps={{ shrink: true }} value={per.de} onChange={(e) => setPer({ ...per, de: e.target.value })} />
          <TextField size="small" type="date" label="Até" InputLabelProps={{ shrink: true }} value={per.ate} onChange={(e) => setPer({ ...per, ate: e.target.value })} />
          <Button size="small" variant="outlined" onClick={() => abrirHtml("/api/documentacao/relatorio", per)}>Relatório</Button>
        </div>
      </MainHeader>
      <Tabs value={aba} onChange={(e, v) => setAba(v)} indicatorColor="primary" textColor="primary">
        <Tab value="ranking" label="Ranking de motivos" /><Tab value="producao" label="Produção e utilidade" />
        <Tab value="demandas" label={`Demandas (${demandas.length})`} /><Tab value="treinamentos" label="Treinamentos" />
      </Tabs>

      {aba === "ranking" && ranking && (
        <>
          <div style={{ display: "flex", gap: 8, margin: "10px 0", flexWrap: "wrap" }}>
            <Numero rotulo="Cards técnicos" valor={ranking.cards_elegiveis} />
            <Numero rotulo="Sem motivo" valor={ranking.qualidade.sem_motivo} />
            <Numero rotulo="Sem cliente" valor={ranking.qualidade.sem_cliente} />
            <Numero rotulo="Sem sistema" valor={ranking.qualidade.sem_sistema} />
          </div>
          <Paper variant="outlined" style={{ overflowX: "auto" }}>
            <Table size="small">
              <TableHead><TableRow><TableCell>#</TableCell><TableCell>Motivo</TableCell><TableCell>Cards</TableCell><TableCell>%</TableCell>
                <TableCell>Manuais ligados</TableCell><TableCell>Cards com manual enviado</TableCell><TableCell /></TableRow></TableHead>
              <TableBody>
                {ranking.motivos.map((m) => (
                  <TableRow key={m.motivo}>
                    <TableCell>{m.posicao}</TableCell><TableCell>{m.motivo}</TableCell><TableCell>{m.cards}</TableCell><TableCell>{m.pct ?? "—"}</TableCell>
                    <TableCell>{m.manuais.length ? m.manuais.map((x) => <Chip key={x.id || x.titulo} size="small" label={x.titulo} style={{ margin: 2 }} />) : "—"}</TableCell>
                    <TableCell>{m.cards_com_envio}</TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>
                      {gerencia && <Button size="small" onClick={() => setLigar(m.motivo)}>Ligar manual</Button>}
                      {gerencia && <Button size="small" onClick={() => setNova({ tema: m.motivo, cards: m.ids || [], acao: m.manuais.length ? "ATUALIZAR" : "CRIAR" })}>Demanda</Button>}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
          <Typography variant="caption">{ranking.observacao}</Typography>
        </>
      )}

      {aba === "producao" && prod && (
        <div style={{ display: "flex", gap: 8, margin: "10px 0", flexWrap: "wrap" }}>
          <Numero rotulo="Manuais criados" valor={prod.manuais_criados} />
          <Numero rotulo="Atualizações publicadas" valor={prod.atualizacoes_publicadas} />
          <Numero rotulo="Revisões sem alteração" valor={prod.revisoes_sem_alteracao} />
          <Numero rotulo="Envios a técnicos" valor={prod.envios_individuais_tecnico} />
          <Numero rotulo="Envios a grupos" valor={prod.envios_grupos} />
          <Numero rotulo="Técnicos distintos" valor={prod.tecnicos_distintos} />
          <Numero rotulo="Manuais distintos enviados" valor={prod.manuais_distintos_enviados} />
          <Numero rotulo="Resolveu: sim / parcial / não" valor={`${prod.utilidade.sim} / ${prod.utilidade.parcial} / ${prod.utilidade.nao}`} />
        </div>
      )}

      {aba === "demandas" && (
        <>
          {gerencia && <Button size="small" startIcon={<AddIcon />} style={{ margin: "10px 0" }} onClick={() => setNova({})}>Nova demanda</Button>}
          <Paper variant="outlined" style={{ overflowX: "auto" }}>
            <Table size="small">
              <TableHead><TableRow><TableCell>Tema</TableCell><TableCell>Ação</TableCell><TableCell>Prioridade</TableCell><TableCell>Casos</TableCell>
                <TableCell>Responsável</TableCell><TableCell>Prazo</TableCell><TableCell>Situação</TableCell><TableCell /></TableRow></TableHead>
              <TableBody>
                {demandas.length === 0 && <TableRow><TableCell colSpan={8}><Typography variant="body2" color="textSecondary">Nenhuma demanda em aberto.</Typography></TableCell></TableRow>}
                {demandas.map((d) => (
                  <TableRow key={d.id}>
                    <TableCell>{d.tema}</TableCell><TableCell>{d.acao}</TableCell><TableCell>{d.prioridade}</TableCell><TableCell>{d.casos}</TableCell>
                    <TableCell>{d.responsavel || "—"}</TableCell><TableCell>{d.prazo ? dataBR(d.prazo, true) : "—"}</TableCell><TableCell>{SIT[d.status]}</TableCell>
                    <TableCell style={{ whiteSpace: "nowrap" }}>{gerencia && (PROXIMOS[d.status] || []).map((s) => <Button key={s} size="small" onClick={() => andar(d, s)}>{SIT[s]}</Button>)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}

      {aba === "treinamentos" && (
        <>
          {treina && <Button size="small" startIcon={<AddIcon />} style={{ margin: "10px 0" }} onClick={() => setNovoT(true)}>Novo treinamento</Button>}
          <Paper variant="outlined" style={{ overflowX: "auto" }}>
            <Table size="small">
              <TableHead><TableRow><TableCell>Título</TableCell><TableCell>Data</TableCell><TableCell>Situação</TableCell>
                <TableCell>Presentes</TableCell><TableCell>Concluíram</TableCell></TableRow></TableHead>
              <TableBody>
                {treinos.map((t) => (
                  <TableRow key={t.id} hover style={{ cursor: "pointer" }} onClick={() => setTreino(t.id)}>
                    <TableCell>{t.titulo}</TableCell><TableCell>{t.data ? dataBR(t.data) : "—"}</TableCell><TableCell>{t.status}</TableCell>
                    <TableCell>{t.presentes}</TableCell><TableCell>{t.concluiram}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}

      <LigarManual motivo={ligar} manuais={manuais} onClose={() => setLigar(null)} onSalvo={carregar} />
      <NovaDemanda open={!!nova} inicial={nova} onClose={() => setNova(null)} onSalvo={carregar} />
      <NovoTreinamento open={novoT} manuais={manuais} onClose={() => setNovoT(false)} onSalvo={carregar} />
      <DetalheTreinamento id={treino} onClose={fecharTreino} onMudou={carregar} />
    </MainContainer>
  );
};

export default Documentacao;
